import {Injectable} from '@angular/core';
import {AuthorizationService} from './authorization.service';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class LocalizationService {

  constructor(private authorizationService: AuthorizationService, private localStorageService: LocalStorageService) {}

  public getStartingLanguage() {
    let result = navigator.language;
    if (this.localStorageService.getCulture()) {
      result = this.localStorageService.getCulture();
    }
    return result;
  }

  public getLanguangeForZendesk(): string{
    if(this.localStorageService.getCulture()){
      switch(this.localStorageService.getCulture().toLowerCase()){
        case 'nl-be':
        case 'nl-nl':
          return 'nl';
        case 'de':
          return 'de';
        case 'fr':
          return 'fr-fr';
        default:
          return 'en-gb';
      }
    }
  }
}
